import { Link } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";


const DataBank = () => {
    const columns = [
        {
            title: "Candidate ID",
            dataIndex: "candidateId",
            sorter: (a: any, b: any) =>
                a.candidateId.localeCompare(b.candidateId),
        },
        {
            title: "Candidate Name",
            dataIndex: "candidateName",
            sorter: (a: any, b: any) =>
                a.candidateName.localeCompare(b.candidateName),
        },
        {
            title: "Applied Position",
            dataIndex: "positionName",
            sorter: (a: any, b: any) =>
                a.positionName.localeCompare(b.positionName),
        },
        {
            title: "Experience",
            dataIndex: "experience",
            sorter: (a: any, b: any) =>
                a.experience.localeCompare(b.experience),
        },
        {
            title: "Rejected Stage",
            dataIndex: "rejectedStage",
            sorter: (a: any, b: any) =>
                a.rejectedStage.localeCompare(b.rejectedStage),
        },
        {
            title: "Reason",
            dataIndex: "reason",
        },
    ];


    const dataSource = [
        {
            key: "1",
            candidateId: "CAND-001",
            candidateName: "Amit Sharma",
            positionName: "Frontend Developer",
            experience: "2.5 Years",
            rejectedStage: "Technical Interview",
            reason: "Weak React concepts",
        },
        {
            key: "2",
            candidateId: "CAND-002",
            candidateName: "Neha Verma",
            positionName: "Backend Developer",
            experience: "3 Years",
            rejectedStage: "HR Round",
            reason: "Salary mismatch",
        },
        {
            key: "3",
            candidateId: "CAND-003",
            candidateName: "Rohit Singh",
            positionName: "UI/UX Designer",
            experience: "1.8 Years",
            rejectedStage: "Portfolio Review",
            reason: "Design quality not matching",
        },
        {
            key: "4",
            candidateId: "CAND-004",
            candidateName: "Pooja Patel",
            positionName: "QA Engineer",
            experience: "2 Years",
            rejectedStage: "Manager Round",
            reason: "Lack of automation experience",
        },
    ];

    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Breadcrumb */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <h2 className="mb-1">Recruitment</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to={all_routes.adminDashboard}>
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item">Recruitment</li>
                                <li className="breadcrumb-item active">Dashboard</li>
                            </ol>
                        </nav>
                    </div>

                    <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                        <CollapseHeader />
                    </div>
                </div>
                {/* /Breadcrumb */}
                <div className="card">
                    <div className="card-body">
                        <Table
                            dataSource={dataSource}
                            columns={columns}
                            Selection={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DataBank;